// extracted by mini-css-extract-plugin
export default {"mandatoryColor":"RadioButton_mandatoryColor__Y3BJx","sottolineato":"RadioButton_sottolineato__nvaOe"};